import Vue from 'vue';
// const VueCurrencyFilter = require('vue-currency-filter');

import VueCurrencyFilter from 'vue-currency-filter';
// import VueCurrencyFilter from 'vue-currency-filter/VueCurrencyFilter.js';
//
Vue.use(VueCurrencyFilter, {
  symbol : 'руб.',
  thousandsSeparator: ' ',
  fractionCount: 0,
  fractionSeparator: '.',
  symbolPosition: 'end of text',
  symbolSpacing: true
});
